'use client';

import { homeConfig } from '@/features/home/home.config';
import { useT } from 'next-i18next/client';
import type { FC } from 'react';

const WHY_CHOOSE_US_ITEMS = [
  {
    statKey: 'home:whyChooseUs.item_0_stat',
    titleKey: 'home:whyChooseUs.item_0_title',
    descriptionKey: 'home:whyChooseUs.item_0_description',
  },
  {
    statKey: 'home:whyChooseUs.item_1_stat',
    titleKey: 'home:whyChooseUs.item_1_title',
    descriptionKey: 'home:whyChooseUs.item_1_description',
  },
  {
    statKey: 'home:whyChooseUs.item_2_stat',
    titleKey: 'home:whyChooseUs.item_2_title',
    descriptionKey: 'home:whyChooseUs.item_2_description',
  },
] as const;

export const WhyChooseUsBlock: FC = () => {
  const { t } = useT(homeConfig.i18nNamespaces);

  return (
    <section className="bg-[#0A0A0A] py-24 md:py-[96px]">
      <div className="container">
        <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E]">
          {t('home:whyChooseUs.label')}
        </p>
        <h2 className="mt-4 text-[clamp(36px,4vw,56px)] font-medium tracking-[-0.025em] leading-[1] text-white">
          {t('home:whyChooseUs.title')}
        </h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {WHY_CHOOSE_US_ITEMS.map((item, index) => (
            <div key={index} className="border-t border-white/10 pt-8">
              <p className="text-[64px] font-medium leading-none tabular-nums text-[#F24E1E]">
                {t(item.statKey)}
              </p>
              <h3 className="mt-4 text-lg font-medium text-white">
                {t(item.titleKey)}
              </h3>
              <p className="mt-2 text-sm text-white/60 leading-relaxed">
                {t(item.descriptionKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
